import Axios from 'axios'

import { parseAuthenticationHeader } from 'helpers/Functions'
import { TSourceResponse } from 'types/GlobalSource'

const homepal_mdm_api =
  process.env.REACT_APP_HOMEPAL_MDM_API_DEV || 'http://localhost:3990/'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? homepal_mdm_api
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/connections/source-tables`

export type TSourceTableBody = {
  data: {
    attributes: Record<string, unknown>
  }
}

/** A raw query result; only the table id is read outside the preview. */
export type TSourceTablePreviewResponse = {
  data: {
    id: string
  }
}

export async function update(id: string, body: TSourceTableBody) {
  const url = `${URL}/${id}`

  return Axios.patch<TSourceResponse>(url, body, parseAuthenticationHeader())
}

export async function getPreview(id: string, limit = 10, offset = 0) {
  return Axios.get<TSourceTablePreviewResponse>(
    `${URL}/${id}?limit=${limit}&offset=${offset}`,
    parseAuthenticationHeader()
  )
}

export async function deleteSourceTable(id: string) {
  const url = `${URL}/${id}`

  return Axios.delete<TSourceResponse>(url, parseAuthenticationHeader())
}
